import { render, staticRenderFns } from "./TitledCardBase.vue?vue&type=template&id=41472e4d&scoped=true&"
import script from "./TitledCardBase.vue?vue&type=script&lang=js&"
export * from "./TitledCardBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41472e4d",
  null
  
)

export default component.exports